import React, { useState } from 'react';
import { PageHeader } from './PageHeader';
import { useLanguage, useTranslation } from '../i18n';
import { apiClient } from '../services/api';
import type { Language } from '../i18n';
import './SettingsPage.css';

export const LanguagePage: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const t = useTranslation();
  const [saving, setSaving] = useState(false);

  const languages: Array<{ code: Language; name: string; flag: string }> = [
    { code: 'es', name: t.languagePage.spanish, flag: '🇪🇸' },
    { code: 'en', name: t.languagePage.english, flag: '🇬🇧' },
  ];

  const handleLanguageSelect = async (langCode: Language) => {
    if (langCode === language || saving) return;

    setSaving(true);
    try {
      await apiClient.updateLanguage(langCode);
      setLanguage(langCode);

      // Haptic feedback
      if (window.Telegram?.WebApp?.HapticFeedback) {
        window.Telegram.WebApp.HapticFeedback.notificationOccurred('success');
      }
    } catch (error) {
      console.error('Failed to update language:', error);
      // Haptic feedback for error
      if (window.Telegram?.WebApp?.HapticFeedback) {
        window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-container settings-page">
      <PageHeader title={t.languagePage.title} />

      <div className="settings-content">
        <div className="settings-group">
          <h2 className="settings-group-title">{t.languagePage.selectLanguage}</h2>
          <div className="language-list">
            {languages.map((lang) => (
              <button
                key={lang.code}
                className={`language-item ${language === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageSelect(lang.code)}
                disabled={saving}
              >
                <div className="language-flag">{lang.flag}</div>
                <div className="language-name">{lang.name}</div>
                {language === lang.code && <div className="language-checkmark">✓</div>}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
